import React from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import { Home, ErrorOutline } from '@mui/icons-material';
import './NotFoundPage.scss';
import { useNavigate } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" style={{ textAlign: 'center', marginTop: '10vh' }}>
      <Box display="flex" flexDirection="column" alignItems="center">
        <ErrorOutline color="error" style={{ fontSize: 80, marginBottom: 16 }} />
        
        <Typography variant="h2" component="h1" gutterBottom>
          404
        </Typography>
        
        <Typography variant="h5" color="textSecondary" gutterBottom>
          Pagina non trovata
        </Typography>
        
        <Typography variant="body1" paragraph color="textSecondary">
          La risorsa che stai cercando potrebbe essere stata rimossa o non è disponibile.
        </Typography>

        <Box mt={4}>
          <Button 
            variant="contained" 
            color="primary" 
            startIcon={<Home />}
            onClick={() => navigate('/')}
          >
            Torna alla Home
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default NotFoundPage;